module.exports = __webpack_public_path__ + "static/img/astrology-metaverse-home-default.10f1ed5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/astrology/astrology-metaverse-home-default.png
// module id = 3JAs
// module chunks = 0